import { render, staticRenderFns } from "./borrower.vue?vue&type=template&id=58bb22b3&scoped=true&"
import script from "./borrower.vue?vue&type=script&lang=js&"
export * from "./borrower.vue?vue&type=script&lang=js&"
import style0 from "./borrower.vue?vue&type=style&index=0&id=58bb22b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bb22b3",
  null
  
)

export default component.exports